import { AvatarProps, Box, Stack, Tooltip } from "@mui/material";
import React, { FC, ReactNode } from "react";
import { StaffHeaderFragment } from "./fragments.types";
import { UserAvatar } from "../../UserAvatar/UserAvatar";
import { StaffContactInfo } from "@sinch/components/application/Staff/StaffHeader/StaffContactInfo";
import { StaffStats } from "@sinch/components/application/Staff/StaffHeader/StaffStats";
import { ProfessionList } from "@sinch/components/application/Staff/StaffHeader/ProfessionList";
import { StaffName } from "@sinch/components/application/Staff/StaffHeader/StaffName";
import { StaffRating } from "@sinch/components/application/Staff/StaffHeader/StaffRating";
import { StaffStatusChips } from "@sinch/components/application/Staff/StaffHeader/StaffStatusChips";
import { useTranslation } from "react-i18next";
import { MdsNotificationsActiveXs, MdsPayments } from "@sinch/icons";
import { MdsIcon } from "@sinch/components";
import { useFormat } from "@sinch/core/hooks/format";
import { IconListRow } from "@sinch/components/IconListRow/IconListRow";
import { isNotNil } from "ramda-adjunct";
import { StaffVerificationStatusChips } from "@sinch/components/application/Staff/StaffHeader/StaffVerificationStatusChips";

interface StaffHeaderProps {
  staff: StaffHeaderFragment;
  actions?: ReactNode;
  avatarSize?: AvatarProps["size"];
}

export const StaffHeader: FC<StaffHeaderProps> = ({ staff, actions, avatarSize }) => {
  const { t } = useTranslation();
  const { num } = useFormat();

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: "start" }}>
      <UserAvatar size={avatarSize} worker={staff} />
      <Stack direction="column">
        <StaffVerificationStatusChips staff={staff} />
        <Stack alignItems="baseline" direction="row" gap={1}>
          <StaffName staff={staff} />
          {(staff.subscribedDevicesCount ?? 0) > 0 && (
            <Tooltip title={t("Staff.subscribedNotifications", { subscribedCount: staff.subscribedDevicesCount ?? 0 })}>
              <MdsIcon fontSize="xs" icon={MdsNotificationsActiveXs} />
            </Tooltip>
          )}
          <StaffRating workerinfo={staff.workerinfo} />
        </Stack>
        <StaffStatusChips staff={staff} />
        <ProfessionList professions={staff.professions} />
        <StaffStats statistics={staff.attendanceStatistics} />{" "}
        {isNotNil(staff.walletStatistics?.balance) && (
          <Tooltip title={t("Staff.walletBalance")}>
            <Box display="inline-block">
              <IconListRow icon={MdsPayments} iconAlign="firstLine" iconSize="xs">
                {num.currency(staff.walletStatistics.balance)}
              </IconListRow>
            </Box>
          </Tooltip>
        )}
        <StaffContactInfo staff={staff} />
      </Stack>
      {actions}
    </Stack>
  );
};
